// src/utils/reportPermissionDenied.js
import { db } from '@/services/firebaseconfig'
import { collection, addDoc, serverTimestamp } from 'firebase/firestore'

// Simple in-memory de-dupe so we don't spam Firestore
const sentKeys = new Set()

/**
 * Report a permission-denied event to Firestore (write-only for normal users).
 * @param {{
 *   kind: 'collection'|'doc'|'page'|'function'|'unknown',
 *   key: string,
 *   action?: 'read'|'write'|'list'|'get'|'navigate'|'call'|'unknown',
 *   message?: string,
 *   meta?: object
 * }} payload
 * @param {object} [authContext] - optional { uid, email, roles }
 */
export async function reportPermissionDenied(payload, authContext = {}) {
  try {
    const kind = payload?.kind || 'unknown'
    const key = payload?.key || 'unknown'
    const action = payload?.action || 'unknown'

    // de-dupe key: kind|key|action|uid
    const dedupeKey = `${kind}|${key}|${action}|${authContext?.uid || 'anon'}`
    if (sentKeys.has(dedupeKey)) return
    sentKeys.add(dedupeKey)

    await addDoc(collection(db, 'permissionDenials'), {
      kind,
      key,
      action,
      message: payload?.message || '',
      meta: payload?.meta || {},
      actor: {
        uid: authContext?.uid || null,
        email: authContext?.email || null,
        roles: authContext?.roles || [],
      },
      createdAt: serverTimestamp(),
    })
  } catch (err) {
    // Must never throw; this is best-effort telemetry
    console.warn('[reportPermissionDenied] Failed to log permission denial:', err)
  }
}
